import PaymentMethodCard from "../billing-details/PaymentMethodCard";
import BillingAddressCard from "../billing-details/BillingAddressCard";
import PaymentHistoryCard from "../billing-details/PaymentHistoryCard";
import PromoCodeCard from "../billing-details/PromoCodeCard";


export default function BillingDetailsTab() {
  return (
    <div className="flex flex-col gap-8 pb-4">
      <PaymentMethodCard/>
      <BillingAddressCard/>
      <PromoCodeCard />
      <PaymentHistoryCard />
    </div>
  );
}
